import React from 'react';
import {
  ShowAppliedFilterWrapper, ShowAppliedFilterLabel,
  FilterTag, InnerWrapper,
} from './styles';

export const ShowAppliedFilterRow = ({
  filterList, filterObj, category,
}) => {
  const { list } = filterObj[category];


  return (
    <div>
      {
        (filterList.length > 0)
          ? (
            <ShowAppliedFilterLabel>
              Filters applied:
            </ShowAppliedFilterLabel>
          ) : (
            <i>No filter applied</i>
          )
      }
      <InnerWrapper>
        {
          filterList.map((item) => {
            const split = item.split('-|');
            const tag = list[split[1]][split[2]];
            const filterCategory = split[1];
            const filterName = split[2];

            if (tag) {
              return (
                <FilterTag
                  key={`filter-${item}`}
                  bg={tag.color}
                  title={`${filterCategory}: ${filterName}`}
                >
                  {filterName && filterName}
                </FilterTag>
              );
            }

            return (list[split[1]] && split[2]) && (
              <FilterTag
                key={`filter-${item}`}
                bg="greyscale.2"
                title={`Unknown: ${item}`}
              >
                {filterName && filterName}
                ?
              </FilterTag>
            );
          })
          // The leaf has to be defined to show a problematic tag.
          // If the leaf is undefined, Antd would treat it as select all
          // children.
        }
      </InnerWrapper>
    </div>
  );
};

export const ShowAppliedFilter = ({
  globalFilterApplied,
  kpiFilterApplied,
  filterObj,
  hideView,
}) => {
  const combinedFilterApplied = globalFilterApplied.concat(kpiFilterApplied);
  const keys = Object.keys(filterObj);
  const combinedFilterObj = {
    combined: {
      label: 'Applied',
      list: filterObj[keys[0]] ? { ...filterObj[keys[0]].list, ...filterObj[keys[1]].list } : {},
    },
  };

  return !hideView && (
    <ShowAppliedFilterWrapper>
      <ShowAppliedFilterRow
        filterObj={combinedFilterObj}
        filterList={combinedFilterApplied}
        category="combined"
      />
    </ShowAppliedFilterWrapper>
  );
};
